/**
 * legalConsent.js — Pure helper for the legal re-consent check.
 *
 * The comparison MUST be ordered ("stored is older than current"), NOT a
 * strict inequality. With `!==` the check is bidirectional: a stale cached
 * bundle (old LEGAL_VERSIONS baked in) sees a NEWER stored consent as a
 * mismatch, re-prompts the user, and its accept write DOWNGRADES the stored
 * version — which then makes the fresh bundle re-prompt again (consent
 * ping-pong between stale and fresh clients after every legal bump).
 *
 * Version strings are ISO dates (YYYY-MM-DD), so lexicographic order equals
 * chronological order.
 */
import { LEGAL_VERSIONS } from "../constants";

export function isConsentOutdated(consent, versions = LEGAL_VERSIONS) {
  if (!consent) return true;
  return !consent.termsVersion || consent.termsVersion < versions.terms ||
         !consent.privacyVersion || consent.privacyVersion < versions.privacy;
}
